export function projectCards(windowWidth, windowHeight) {
    let projectCardHoverFunc = () => {
        let cards = document.querySelectorAll(".project-display-card")
        if (cards) {
            cards.forEach((el) => {
                if (!el.classList.contains("callout")) {
                    let context = el.querySelector(".context-inner")
                    let content = el.querySelector(".context-inner .content")
                    let height = content.getBoundingClientRect().height
                    context.style.transform = "translateY(" + height + "px)"
                }
            })
        }

        let proofs = document.querySelectorAll(".proofpoints-section")
        if (proofs) {
            proofs.forEach((el) => {
                let context = el.querySelector(".context-inner")
                let content = el.querySelector(".context-inner .content")
                let height = content.offsetHeight
                context.style.transform = "translateY(" + height + "px)"
            })
        }
    }

    window.addEventListener("resize", (event) => {
        projectCardHoverFunc()
    })

    if (windowWidth > 1200) {
        projectCardHoverFunc()
    }
}